// Re-export the `contextSrv` inside a getter function so it's easier to mock.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
export const getContextSrv: () => any = () => require('grafana/app/core/core').contextSrv;
